"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var forms_1 = require("@angular/forms");
var service_service_1 = require("src/app/Services/service.service");
var material_1 = require("@angular/material");
var RegisterComponent = /** @class */ (function () {
    function RegisterComponent(fb, services, dialogRef) {
        this.fb = fb;
        this.services = services;
        this.dialogRef = dialogRef;
        this.enablePhoneRegConfirm = false;
        this.registrationForm = this.fb.group({
            email: [null, forms_1.Validators.compose([forms_1.Validators.required, forms_1.Validators.email])],
            password: [null, forms_1.Validators.compose([forms_1.Validators.required, forms_1.Validators.minLength(5)])],
            passwordConfirm: [null, forms_1.Validators.compose([forms_1.Validators.required, confirmPasswordValidator()])],
            phone: [null, forms_1.Validators.required],
            igreeDisclaimer: [false, forms_1.Validators.requiredTrue]
        }, { validators: exports.registrationFormValidate });
        this.states = [
            { name: "Alabama", abbreviation: "AL" },
            { name: "Alaska", abbreviation: "AK" },
            { name: "American Samoa", abbreviation: "AS" },
            { name: "Arizona", abbreviation: "AZ" },
            { name: "Arkansas", abbreviation: "AR" },
            { name: "California", abbreviation: "CA" },
            { name: "Colorado", abbreviation: "CO" },
            { name: "Connecticut", abbreviation: "CT" },
            { name: "Delaware", abbreviation: "DE" },
            { name: "District Of Columbia", abbreviation: "DC" },
            { name: "Federated States Of Micronesia", abbreviation: "FM" },
            { name: "Florida", abbreviation: "FL" },
            { name: "Georgia", abbreviation: "GA" },
            { name: "Guam", abbreviation: "GU" },
            { name: "Hawaii", abbreviation: "HI" },
            { name: "Idaho", abbreviation: "ID" },
            { name: "Illinois", abbreviation: "IL" },
            { name: "Indiana", abbreviation: "IN" },
            { name: "Iowa", abbreviation: "IA" },
            { name: "Kansas", abbreviation: "KS" },
            { name: "Kentucky", abbreviation: "KY" },
            { name: "Louisiana", abbreviation: "LA" },
            { name: "Maine", abbreviation: "ME" },
            { name: "Marshall Islands", abbreviation: "MH" },
            { name: "Maryland", abbreviation: "MD" },
            { name: "Massachusetts", abbreviation: "MA" },
            { name: "Michigan", abbreviation: "MI" },
            { name: "Minnesota", abbreviation: "MN" },
            { name: "Mississippi", abbreviation: "MS" },
            { name: "Missouri", abbreviation: "MO" },
            { name: "Montana", abbreviation: "MT" },
            { name: "Nebraska", abbreviation: "NE" },
            { name: "Nevada", abbreviation: "NV" },
            { name: "New Hampshire", abbreviation: "NH" },
            { name: "New Jersey", abbreviation: "NJ" },
            { name: "New Mexico", abbreviation: "NM" },
            { name: "New York", abbreviation: "NY" },
            { name: "North Carolina", abbreviation: "NC" },
            { name: "North Dakota", abbreviation: "ND" },
            { name: "Northern Mariana Islands", abbreviation: "MP" },
            { name: "Ohio", abbreviation: "OH" },
            { name: "Oklahoma", abbreviation: "OK" },
            { name: "Oregon", abbreviation: "OR" },
            { name: "Palau", abbreviation: "PW" },
            { name: "Pennsylvania", abbreviation: "PA" },
            { name: "Puerto Rico", abbreviation: "PR" },
            { name: "Rhode Island", abbreviation: "RI" },
            { name: "South Carolina", abbreviation: "SC" },
            { name: "South Dakota", abbreviation: "SD" },
            { name: "Tennessee", abbreviation: "TN" },
            { name: "Texas", abbreviation: "TX" },
            { name: "Utah", abbreviation: "UT" },
            { name: "Vermont", abbreviation: "VT" },
            { name: "Virgin Islands", abbreviation: "VI" },
            { name: "Virginia", abbreviation: "VA" },
            { name: "Washington", abbreviation: "WA" },
            { name: "West Virginia", abbreviation: "WV" },
            { name: "Wisconsin", abbreviation: "WI" },
            { name: "Wyoming", abbreviation: "WY" }
        ];
        this.loading = false;
        this._captchaResolvedFlag = false;
        this.afterRegClose = false;
        this.enablePhoneRegConfirm = services.enablePhoneRegConfirm;
        this.registrationForm.controls["igreeDisclaimer"].setValue(false);
    }
    RegisterComponent.prototype.getCaptchaResolvedFlag = function () {
        return this._captchaResolvedFlag;
    };
    RegisterComponent.prototype.setCaptchaResolvedFlag = function (value) {
        this._captchaResolvedFlag = value;
    };
    RegisterComponent.prototype.captchaResolved = function (captchaResponse) {
        this.setCaptchaResolvedFlag(true);
    };
    RegisterComponent.prototype.captchaAvailable = function () {
        return this.services.captchaService.getCurrentCaptchaKey() != "";
    };
    RegisterComponent.prototype.isCaptchaOk = function () {
        return this.captchaAvailable() && this._captchaResolvedFlag;
    };
    RegisterComponent.prototype.isEmailNotValid = function () {
        return this.registrationForm.controls["email"].hasError("required") || this.registrationForm.controls["email"].hasError("email");
    };
    RegisterComponent.prototype.getEmailErrorMessage = function () {
        return this.registrationForm.controls["email"].hasError("required") ? "Email is required" : this.registrationForm.controls["email"].hasError("email") ? "Enter valid email address" : "";
    };
    RegisterComponent.prototype.isPasswordNotValid = function () {
        return this.registrationForm.controls["password"].hasError("required") || this.registrationForm.controls["password"].hasError("minlength") || this.registrationForm.hasError("passwordConfirmed");
    };
    RegisterComponent.prototype.getPasswordErrorMessage = function () {
        return this.registrationForm.controls["password"].hasError("required")
            ? "Password is required"
            : this.registrationForm.controls["password"].hasError("minlength")
                ? "Password must have at 5 chars length."
                : this.registrationForm.hasError("passwordConfirmed")
                    ? "Password and Confirmation must be equal."
                    : "";
    };
    RegisterComponent.prototype.isPasswordConfirmNotValid = function () {
        return (this.registrationForm.controls["passwordConfirm"].hasError("required") || this.registrationForm.controls["passwordConfirm"].value != this.registrationForm.controls["passwordConfirm"].value || this.registrationForm.hasError("passwordConfirmed"));
    };
    RegisterComponent.prototype.getPasswordConfirmErrorMessage = function () {
        return this.registrationForm.controls["passwordConfirm"].hasError("required") ? "Password Confirmation is required" : this.registrationForm.hasError("passwordConfirmed") ? "Password and Confirmation must be equal." : "";
    };
    RegisterComponent.prototype.onSubmit = function () {
        var _this = this;
        this.validateAllFormFields(this.registrationForm);
        if (!this.registrationForm.invalid) {
            if (!this.isCaptchaOk()) {
                this.services.showError("Please confirm the captcha");
            }
            else {
                this.loading = true;
                this.services.userService
                    .register(this.registrationForm.controls["email"].value, this.registrationForm.controls["phone"].value, this.registrationForm.controls["password"].value, this.registrationForm.controls["passwordConfirm"].value, "registration-success")
                    .then(function (r) {
                    _this.services.route.navigate([r]);
                    _this.afterRegClose = true;
                    _this.dialogRef.close();
                    _this.loading = false;
                })
                    .catch(function (e) {
                    _this.loading = false;
                    _this.services.showError(e);
                });
            }
        }
    };
    RegisterComponent.prototype.validateAllFormFields = function (formGroup) {
        var _this = this;
        Object.keys(formGroup.controls).forEach(function (field) {
            var control = formGroup.get(field); //{3}
            if (control instanceof forms_1.FormControl) { //{4}
                control.markAsTouched({ onlySelf: true });
            }
            else if (control instanceof forms_1.FormGroup) { //{5}
                _this.validateAllFormFields(control); //{6}
            }
        });
    };
    RegisterComponent.prototype.formControlIsValid = function (formGroup, formCtrl) {
        if (formGroup.controls.hasOwnProperty(formCtrl)) {
            if (!formGroup.controls[formCtrl].touched)
                return true;
            return formGroup.controls[formCtrl].valid;
        }
        return false;
    };
    return RegisterComponent;
}());
exports.RegisterComponent = RegisterComponent;
function confirmPasswordValidator() {
    return function (control) {
        var p = control.parent ? control.parent.controls["password"].value : "";
        var pc = control.parent ? control.parent.controls["passwordConfirm"].value : "";
        return p != pc ? { passwordConfirm: { value: control.value } } : null;
    };
}
exports.confirmPasswordValidator = confirmPasswordValidator;
exports.registrationFormValidate = function (control) {
    var p = control.get("password");
    var pc = control.get("passwordConfirm");
    var res = p && pc && pc.value === p.value ? null : { passwordConfirmed: true };
    return res;
};
